<template>
  <el-container class="line-notify">
    
    <!-- Page Header -->
    <el-header
      class="page-header"
      height="max-content">
      <h4 class="header-title">
        <b>
          {{ title }}
        </b>
      </h4>  
    </el-header>
    
    <!-- Page Content -->
    <el-main class="page-main">
      <router-view :width="width" />
    </el-main>
  
  </el-container>
</template>

<script>
export default {
  name: 'LineNotifyHome',
  data () {
    return {
      title: 'ผู้ใช้งาน LINE Notice ',
      width: 0
    }
  },
  created () {

    // Initialized Width
    this.width = window.outerWidth

    // Resize Event
    window.addEventListener("resize", ({ target }) => {
      this.width = target.outerWidth
    });
  },
}

</script>

<style scoped>

@import url('../LineNotify.css');

</style>